import { Pipe } from '@angular/core';
import type { PipeTransform } from '@angular/core';
import type { TTimestamp } from '@shared/models';
import { DateService } from '@shared/services';

@Pipe({
    'name': 'myTimestamp',
    'standalone': true,
    // pure: true
})
export class MyTimestampPipe implements PipeTransform {
    private dateService: DateService = new DateService();

    transform(value: unknown, ...args: unknown[]): string {
        const timestamp = value as TTimestamp;
        const format = args[0] as string;
        const minimumDate = -62135596800;       // = this.dateService.getMinimumDate();

        // if (!timestamp || !format || timestamp === this.dateService.getMinimumDate()) {
        if (!timestamp || !format || timestamp.seconds === minimumDate) {
            return '';
        }
        const str = this.dateService.formatTimestamp(timestamp, format);
        return str;
    }
}
